import openFullScreen from '../libs/images/open-full-screen.svg'
export let model = {
  menu: [],
  menuPath: {},
  tabs: [],
  contextmenuVisible: false,
  contextmenuTabName: undefined,
  isInit: false,
  wsAlarm: false,
  wsExcelUpload: false,
  wsExcelUploadPop: false,
  wsExcelUploadRowIds: [], // 导出历史里最新的消息的id数组
  wsDodgetollRecoed: false,
  wsExcelUploadNum: 0,
  fullScreenImgSrc: openFullScreen,
  menuShow: false,
  situation: {
    visible: false
  },
  textList: [],
  isShowQRCode: false,
  isUtterThisPlay: true,
  utterThisList: [],
  deviceAlarmState: false,
  user: {
    visible: false,
    title: '修改',
    type: undefined,
    formData: {
      photo: undefined,
      realName: undefined,
      loginName: undefined,
      organizationName: undefined,
      headIcon: undefined,
      userId: undefined
    }
  },
  rules: {
    realName: [
      { required: true, message: '请输入姓名', trigger: 'blur' }
    ]
  },
  importFile: {
    input: {
      value: {},
      fileList: [],
      dialogVisible: false,
      iscustom: 1,//是否自定义,1是
      plateRules: {
        uploadFileType: [
          { required: true, message: '请选择', trigger: 'blur' }
        ]
      }
    }
  },
}
export let computed = {
  indexLogo(){
    // 动态的logo
    let logoSrc = '/static/img/';
    logoSrc += window.CONFIG.INDEX_LOGO ? window.CONFIG.INDEX_LOGO : 'logo.png';
    return logoSrc
  },
  dict: {
    get () {
      return this.$store.state.app.dict
    },
    set (val) {
      this.$store.state.app.dict = val
    }
  },
  role: {
    get () {
      return this.$store.state.app.role
    },
    set (val) {
      this.$store.state.app.role = val
    }
  },
  keepAliveExclude () {
    return this.$store.state.app.keepAliveExclude
  },
  titles () {
    let titles = {}
    findTitles(this.menuWithName)
    function findTitles (arr) {
      arr.forEach(item => {
        if (item.name) {
          titles[item.name] = item.title
        }
        if (item.children && item.children.length) {
          findTitles(item.children)
        }
      })
    }
    return titles
  },
  pagePath () {
    return this.$route.path
  },
  pageName: {
    get () {
      let name = this.$route.name ? this.$route.name : location.hash.replace('#/', '')
      if (!name) {
        name = 'index'
      }
      name = name.split('/')
      name = name[0]
      if (name === 'index') {
        this.menuShow = false
      } else if (name === 'login') {
        this.menuShow = false
      }
      return name
    },
    set (val) {
      // 什么也不干
    }
  },
  closable () {
    return this.tabs.length > 1
  },
  menuWithName () {
    let menu = this.menu
    function addName (arr) {
      arr.forEach(item => {
        if (item.path) {
          item.name = item.path.match(/^\/([^/]+)/)[1]
          this.menuPath[item.name] = item.path
        }
        if (item.children) {
          addName.call(this, item.children)
        }
      })
    }
    addName.call(this, menu)
    return menu
  },
  wsAlarmPop: {
    get () {
      return this.$store.state.app.wsAlarmPop
    },
    set (val) {
      this.$store.state.app.wsAlarmPop = val
    }
  },
  wsAlarmPopNum: {
    get () {
      return this.$store.state.app.wsAlarmPopNum
    },
    set (val) {
      this.$store.state.app.wsAlarmPopNum = val
    }
  },
  action: {
    get() {
      // var ipExec = /(http(s)?:\/\/)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62}|(:[0-9]{1,4}))+\.?/
      // let ip = ipExec.exec(window.CONFIG.HOST + this.suspectVehicle.input.value.roadNo)
      // let action = ip[0] + '/' + this.suspectVehicle.input.value.roadNo + '/' + 'suspectVehicle/splitUpload.htm'
      let action = window.CONFIG.HOST + 'suspectVehicle/splitUpload.htm';
      return action;
    }
  }
}
